export const BASE_METRIC_NAME = 'backstage';
export const NEO4J_SEARCH_EVENT_NAME = 'search-neo4j';
export const EXHAUSTED_RETRIES_ERROR_BASE = 'Exhausted attempts to send metric';
export const FAILED_TO_SEND_METRIC_ERROR_BASE = 'Failed to send metric';
